import { GlobalService } from 'src/app/service/global.service';
import { ContactSupportDto } from 'src/app/DTO/contact-support.dto';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { PharmacieService } from 'src/app/service/pharmacie.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contact-support-modal',
  templateUrl: './contact-support-modal.component.html',
  styleUrls: ['./contact-support-modal.component.scss']
})
export class ContactSupportModalComponent implements OnInit {
  @Input() 
  sendFormEvent: Observable<void>;
  private sendFormEventSubscription: Subscription;
  
  @Output()
  private modalContactSupport: EventEmitter<boolean> = new EventEmitter();

  contactSupportForm: FormGroup;
  protected ticketSupport: ContactSupportDto;
  recontactMethode = 'tel';

  public submitted = false;
  buttonDisabled: boolean = false;

  constructor(
    private contactForm: FormBuilder, 
    private globalService: GlobalService,
    private pharmacieService: PharmacieService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {

    this.ticketSupport = new ContactSupportDto();
    this.ticketSupport.setCodeSogiphar(this.globalService.pharmacie.codeSogiphar);
    this.ticketSupport.setRecontactMethode('tel');
    this.modalContactSupport.emit(true);

    this.contactSupportForm = this.contactForm.group({
      object: this.contactForm.control(this.ticketSupport.object, [Validators.required]),
      message: this.contactForm.control(this.ticketSupport.message, [Validators.required]),
      recontactMethode: this.contactForm.control(this.ticketSupport.recontactMethode, [Validators.required]),
      tel: this.contactForm.control(this.ticketSupport.recontactInfo, [Validators.required]),
      mail: this.contactForm.control(this.ticketSupport.recontactInfo, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
    })

    this.sendFormEventSubscription = this.sendFormEvent.subscribe(() => this.onSubmit());
  }

  closeModal() {
    this.modalContactSupport.emit(false);
  }

  get field() {
    return this.contactSupportForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.contactSupportForm.value.recontactMethode === 'tel') {
      this.disableValidatorOnField('mail');
    } else {
      this.disableValidatorOnField('tel');
    }

    console.log(this.contactSupportForm);
    
    // stop here if form is invalid
    if (this.contactSupportForm.invalid) {
      if (this.contactSupportForm.value.recontactMethode === 'mail') {
        this.contactSupportForm.get('tel').setValidators([Validators.required]);
        this.contactSupportForm.get('tel').updateValueAndValidity();
      } else {
        this.contactSupportForm.get('mail').setValidators([Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]);
        this.contactSupportForm.get('mail').updateValueAndValidity();
      }
      return;
    }
    
    this.buttonDisabled = true;

    this.ticketSupport
      .setSupportObject(this.contactSupportForm.value.object)
      .setMessage(this.contactSupportForm.value.message)
      .setRecontactMethode(this.contactSupportForm.value.recontactMethode)
      .setRecontactInfo(this.contactSupportForm.value.recontactMethode === 'tel' ? this.contactSupportForm.value.tel : this.contactSupportForm.value.mail);

    this.pharmacieService.postContactSupport(this.ticketSupport).subscribe(data => {
      this.toastr.success("Le mail a été transféré au support !");
      this.buttonDisabled = false;
      this.closeModal();
    }, err => {
      console.log(err);
      this.toastr.error("Un problème est survenu. Merci de réessayer plus tard");
    });
  }

  disableValidatorOnField(fieldName: string) {
    this.contactSupportForm.get(fieldName).clearValidators();
    this.contactSupportForm.get(fieldName).updateValueAndValidity();
  }
}
